document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("header.header");

  if (!header) return;

  let lastScrollTop = 10;
  const headerHeight = header.offsetHeight;

  window.addEventListener("scroll", () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // At the top of the page
      if (scrollTop <= 10) {
        header.classList.remove("header--hidden");
        header.classList.remove("header--visible");
        lastScrollTop = 10;
        return;
      }

      // Scrolling down
      if (scrollTop > lastScrollTop) {
        header.classList.add("header--hidden");
        header.classList.remove("header--visible");
      }
      else {
        header.classList.remove("header--hidden");
        header.classList.add("header--visible");
      }

      lastScrollTop = scrollTop;
    },
    { passive: true }
  );
});